export class Part {
	number = 1;
	name = '';
	sheetThickness = '';
	magnelisCoatingMass = '';
	corrosion = '';
	fabricationProcess = '';
	epassivationEasyfilm = '';
}
